import { format, startOfMonth, subMonths } from 'date-fns';
import { Loader2 } from 'lucide-react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { useGetEnrollmentGrowth } from '~entities/dashboard/api/get-enrollment-growth';

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '~shared/shadcn/ui/card';

// const data = [
//   {
//     month: 'Jul',
//     added: 28,
//     dropped: 5,
//     addedLastYear: 25,
//     droppedLastYear: 7,
//   },
//   {
//     month: 'Aug',
//     added: 35,
//     dropped: 8,
//     addedLastYear: 30,
//     droppedLastYear: 10,
//   },
//   {
//     month: 'Sep',
//     added: 22,
//     dropped: 12,
//     addedLastYear: 20,
//     droppedLastYear: 15,
//   },
//   {
//     month: 'Oct',
//     added: 42,
//     dropped: 6,
//     addedLastYear: 38,
//     droppedLastYear: 8,
//   },
//   {
//     month: 'Nov',
//     added: 31,
//     dropped: 9,
//     addedLastYear: 28,
//     droppedLastYear: 11,
//   },
//   {
//     month: 'Dec',
//     added: 38,
//     dropped: 4,
//     addedLastYear: 35,
//     droppedLastYear: 6,
//   },
// ];

const today = new Date();
const formattedToday = format(today, 'yyyy-MM-dd');
const sixMonthsAgo = subMonths(today, 5);
const firstOfMonth = startOfMonth(sixMonthsAgo);
const formattedFirstOfMonth = format(firstOfMonth, 'yyyy-MM-dd');

interface EnrollmentGrowthChartProps {
  sessionId: string;
}

export function EnrollmentGrowthChart({
  sessionId,
}: EnrollmentGrowthChartProps) {
  // const [showComparison, setShowComparison] = useState(false);

  const { data: enrollmentGrowthData, isLoading: isEnrollmentGrowthLoading } =
    useGetEnrollmentGrowth({
      sessionId,
      startDate: formattedFirstOfMonth,
      endDate: formattedToday,
    });

  return (
    <Card>
      <CardHeader className='pb-4'>
        <div className='flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
          <div>
            <CardTitle className='text-lg font-semibold text-[#000814]'>
              Enrollment Growth
            </CardTitle>
            <p className='text-sm text-[#6B7280]'>Added vs dropped students</p>
          </div>
          <div className='flex items-center gap-2'>
            {/* <Link
              href='/reports/enrollment'
              className='group flex items-center gap-1 text-xs text-[#6B7280] transition-colors hover:text-[#000814]'
              to={''}
            >
              View Full Report
              <ArrowRight className='size-3 transition-transform group-hover:translate-x-0.5' />
            </Link> */}
            {/* <Button
              variant='outline'
              size='sm'
              onClick={() => {
                setShowComparison(!showComparison);
              }}
              className='text-xs'
            >
              Show YoY Comparison
              <ChevronDown className='ml-1 size-3' />
            </Button> */}
          </div>
        </div>
      </CardHeader>
      <CardContent>
        {isEnrollmentGrowthLoading ? (
          <div className='flex h-[280px] items-center justify-center'>
            <Loader2 className='size-10 animate-spin' />
          </div>
        ) : (
          <ResponsiveContainer width='100%' height={280}>
            <BarChart data={enrollmentGrowthData}>
              <CartesianGrid
                strokeDasharray='3 3'
                stroke='#E5E7EB'
                vertical={false}
              />
              <XAxis
                dataKey='month'
                stroke='#475569'
                fontSize={12}
                fontWeight={500}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                stroke='#475569'
                fontSize={12}
                fontWeight={500}
                tickLine={false}
                axisLine={false}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: 'white',
                  border: '1px solid #E5E7EB',
                  borderRadius: '12px',
                  padding: '8px 12px',
                }}
              />
              <Legend
                wrapperStyle={{ paddingTop: '20px' }}
                iconType='circle'
                formatter={(value) => (
                  <span className='text-sm font-medium text-[#6B7280]'>
                    {value}
                  </span>
                )}
              />
              <Bar
                dataKey='added'
                fill='#16A34A'
                radius={[8, 8, 0, 0]}
                name='Added'
                animationDuration={240}
              />
              <Bar
                dataKey='dropped'
                fill='#DC2626'
                radius={[8, 8, 0, 0]}
                name='Dropped'
                animationDuration={240}
              />
              {/* {showComparison && (
              <>
                <Bar
                  dataKey='addedLastYear'
                  fill='#86EFAC'
                  radius={[8, 8, 0, 0]}
                  name='Added (Last Year)'
                  animationDuration={240}
                />
                <Bar
                  dataKey='droppedLastYear'
                  fill='#FCA5A5'
                  radius={[8, 8, 0, 0]}
                  name='Dropped (Last Year)'
                  animationDuration={240}
                />
              </>
            )} */}
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
